var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1832 45C9.76156 44.8219 -0.175764 34.6032 0.00235763 22.1814C0.105481 15.122 3.51792 8.51267 9.21782 4.34082L14.7115 11.9345C8.88033 16.2376 7.64285 24.4595 11.9459 30.2907C14.374 33.5719 18.1802 35.5407 22.2676 35.6157L22.1832 45Z",
    fill: "#57068C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42432 4.19075C19.4554 -2.97171 33.377 -0.731098 40.6613 9.21572L33.0677 14.7094C28.8209 8.9626 20.7585 7.65948 14.9273 11.7938L9.42432 4.19075Z",
    fill: "#FDD835"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8112 9.42188C46.8111 17.8218 46.3236 29.2218 39.6393 37.078L32.5332 30.9655C36.3863 26.3999 36.6675 19.7999 33.2176 14.9156L40.8112 9.42188Z",
    fill: "#00A8F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4705 37.2748C35.1862 42.1967 28.9707 45.0185 22.4458 44.9998L22.5208 35.6248C26.2895 35.6155 29.8707 33.9936 32.3644 31.1624L39.4705 37.2748Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d88f5f2974fa05cd1df2c93bcf8c35d2.svg";
export { ForwardRef as ReactComponent };